import React from "react";
import PropTypes from "prop-types";

import { Field } from "react-final-form";

const RadioFilterOption = ({ name, option }) => (
  <Field name={name} value={option.key} type="radio">
    {({ input }) => {
      const classNames = ["radio-filter-option__inner"];

      return (
        <div className="radio-filter-option">
          <label
            className={classNames.join(" ")}
            htmlFor={`${input.name}-${input.value}`}
          >
            <input
              id={`${input.name}-${input.value}`}
              className="radio-filter-option__input"
              type="radio"
              {...input}
            />
            <span className="radio-filter-option__label">{option.title}</span>
          </label>
        </div>
      );
    }}
  </Field>
);

RadioFilterOption.propTypes = {
  name: PropTypes.string.isRequired,
  option: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default RadioFilterOption;
